
<template>
  <ValidationObserver
    ref="observer"
    v-slot="observer">
    <form @submit.prevent="customPasses(onSubmit)">
      <BaseCheckboxGroupWithProvider
        v-model="form.residencePreference"
        label="希望エリア"
        name="希望エリア"
        vid="residencePreference"
        :options="residencePreferenceOptions"
        rules="required"
        :response-errors="apiErrors" />
      <BaseCheckboxGroupWithProvider
        v-model="form.preferredPath"
        label="希望進路"
        name="希望進路"
        vid="preferredPath"
        :options="preferredPathOptions"
        rules="required"
        :response-errors="apiErrors" />
      <BaseCheckboxGroupWithProvider
        v-model="form.examType"
        label="受験タイプ"
        name="受験タイプ"
        vid="examType"
        :options="examTypeOptions"
        rules="required"
        :response-errors="apiErrors" />
      <hr class="my-4">
      <BaseTextFieldGroupWithProvider
        v-model="form.nearestStation"
        label="自宅の最寄駅・バス停"
        vid="nearestStation"
        name="自宅の最寄駅・バス停"
        rules="max:50"
        :response-errors="apiErrors" />
      <BaseTextFieldGroupWithProvider
        v-model="form.accessTime"
        label="最寄駅・バス停までの時間"
        vid="accessTime"
        name="最寄駅・バス停までの時間"
        rules="max:50"
        :response-errors="apiErrors" />
      <BaseTextareaGroupWithProvider
        v-model="form.preference"
        label="生徒希望欄"
        vid="preference"
        name="生徒希望欄"
        placeholder="どのような高校・大学・チームを希望しているのか？具体的な条件を書いてください"
        :response-errors="apiErrors" />
      <BaseTextareaGroupWithProvider
        v-model="form.parentPreference"
        label="保護者希望欄"
        vid="parentPreference"
        name="保護者希望欄"
        placeholder="学費・部費・寮費などの予算や保護者の希望条件を書いてください"
        :response-errors="apiErrors" />
      <hr class="my-4">
      <label class="font-weight-bold">
        希望進学先（学校名/チーム名など）
      </label>
      <BaseTextFieldGroupWithProvider
        v-model="form.firstPreferredSchool"
        label="第1希望"
        vid="firstPreferredSchool"
        name="第1希望"
        rules="max:30"
        :response-errors="apiErrors" />
      <BaseTextFieldGroupWithProvider
        v-model="form.secondPreferredSchool"
        label="第2希望"
        vid="secondPreferredSchool"
        name="第2希望"
        rules="max:30"
        :response-errors="apiErrors" />
      <BaseTextFieldGroupWithProvider
        v-model="form.thirdPreferredSchool"
        label="第3希望"
        vid="thirdPreferredSchool"
        name="第3希望"
        rules="max:30"
        :response-errors="apiErrors" />
      <BaseTextFieldGroupWithProvider
        v-model="form.fourthPreferredSchool"
        label="第4希望"
        vid="fourthPreferredSchool"
        name="第4希望"
        rules="max:30"
        :response-errors="apiErrors" />
      <BaseTextFieldGroupWithProvider
        v-model="form.fifthPreferredSchool"
        label="第5希望"
        vid="fifthPreferredSchool"
        name="第5希望"
        rules="max:30"
        :response-errors="apiErrors" />
      <div
        class="d-flex justify-content-between mt-4"
        style="gap: 16px;">
        <button
          type="button"
          class="btn btn-block btn-cancel"
          @click="onClickCancel">
          キャンセル
        </button>
        <button
          type="submit"
          class="btn btn-block btn-primary mt-0">
          保存
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import BaseTextFieldGroupWithProvider from '@/components/parts/BaseTextFieldGroupWithProvider.vue'
import BaseTextareaGroupWithProvider from '@/components/parts/BaseTextareaGroupWithProvider.vue'
import BaseCheckboxGroupWithProvider from '@/components/parts/BaseCheckboxGroupWithProvider.vue'
import validateMixin from '@/components/mixin/validate'
import { residencePreferenceOptions, preferredPathOptions, examTypeOptions } from '@/helper/profile'

export default {
  components: {
    BaseTextFieldGroupWithProvider,
    BaseTextareaGroupWithProvider,
    BaseCheckboxGroupWithProvider,
  },
  mixins: [validateMixin],
  props: {
    pathSurveys: {
      type: Object,
      default: null,
    },
    userId: {
      type: String,
      default: null,
    },
    apiErrors: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        user: this.userId,
        residencePreference: [],
        preferredPath: [],
        examType: [],
        nearestStation: '',
        accessTime: '',
        preference: '',
        parentPreference: '',
        firstPreferredSchool: '',
        secondPreferredSchool: '',
        thirdPreferredSchool: '',
        fourthPreferredSchool: '',
        fifthPreferredSchool: ''
      }
    }
  },
  computed: {
    residencePreferenceOptions() {
      return residencePreferenceOptions
    },
    preferredPathOptions() {
      return preferredPathOptions
    },
    examTypeOptions() {
      return examTypeOptions
    }
  },
  created() {
    if (this.pathSurveys) {
      this.form = this.pathSurveys
    }
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.form)
    },
    onClickCancel() {
      this.$router.back()
    }
  }
}
</script>

<style>

</style>